import React from 'react';
import AccessChecker from '../../shared/authorization/AccessChecker';
import { TeamPermission } from 'nekst-api';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import { CurrentUserSenderEmailWidget } from 'features/tasks-forms';
import useSettingsNavigator from '../settingsNavigator';
import InnerBlock from '../../shared/web/layout/InnerBlock';

export default function SendingEmailPage() {
  const settingsNavigator = useSettingsNavigator();

  return (
    <AccessChecker
      permissionToCheck={TeamPermission.FEATURE_EMAIL_CONFIGURATION}
    >
      <SettingsBreadcrumbs>
        <Breadcrumb text="Email Setup" />
      </SettingsBreadcrumbs>
      <InnerBlock title="Email Setup">
        <CurrentUserSenderEmailWidget
          openEmailConfigurationPage={settingsNavigator.openEmailConfigurationPage}
        />
      </InnerBlock>
    </AccessChecker>
  );
}
